import { useSerialNumberContext } from '../serial-number-context';

export type SerializableLineItem = {
  itemId: number;
  itemQuantity: number;
  requiresSerialNumber: boolean;
};

// True when at least one item that requires a serial number doesn't have one
// captured yet for every unit. Reads from SerialNumberProvider's context, so a
// SerialNumberProvider ancestor must be present (fulfillmentPlanId set) for this
// to reflect real data — see serial-number-context.tsx. Counts only non-blank
// entries, matching SerialNumberStatus's isComplete check (a placeholder row
// with an empty serialNumber string doesn't count as captured).
export const useHasMissingRequiredSerials = (items: readonly SerializableLineItem[]): boolean => {
  const { getSerialNumbers } = useSerialNumberContext();

  return items.some((item) => {
    if (!item.requiresSerialNumber) {
      return false;
    }
    const enteredCount = getSerialNumbers(item.itemId).filter((serial) => serial.serialNumber.trim().length > 0).length;
    return enteredCount < item.itemQuantity;
  });
};
